<template>
  <a-row>
    <a-col span="6" style="padding-right: 10px;">
      <a-card title="AI解析试题" :bordered="false" :style="{ height: calculateRowHeight() }"> 
        <a-textarea 
          v-model="aiImportText" 
          placeholder="请输入AI导题文本" 
          :style="{ height: calculateTextareaHeight() }"
        />
        <a-button type="primary" style="margin-top: 10px;" block @click="importDrill" :loading="loading">解析试题</a-button>
      </a-card>
    </a-col>
    <a-col span="18" style="padding-left: 10px;">
      <a-card title="AI解析结果" :bordered="false" :style="{ height: calculateRowHeight() }" style="overflow-y: auto;"> 
        <a-row v-for="(drill, index) in drillList" :key="index"> 
          <ChoiceQuestionAIEdit v-if="drill.subType === 101" :drill="drill" :index="index" :sectionId="sectionId" @updateDrill="updateDrill"/>
        </a-row>
      </a-card>
    </a-col>
  </a-row>
</template>

<script>
import fetch from 'isomorphic-fetch';
import ChoiceQuestionAIEdit from './drillItem/ChoiceQuestionAIEdit.vue'
export default {
  name: 'textbookAIImport',
  components: {
    ChoiceQuestionAIEdit
  },
  data() {
    return {
      loading: false,
      aiImportText: '',
      drillList: [],
      sourceDrillList: [],
      textbookId: undefined,
      unitId: undefined,
      lessonId: undefined,
      sectionId: undefined
    }
  },
  watch: {
    'sourceDrillList.length': function(newVal, oldVal) {
      this.drillList = this.sourceDrillList
    }
  },
  async created() {
    let {textbookId, unitId, lessonId, sectionId} = this.$route.params;
    console.log({textbookId, unitId, lessonId, sectionId})
    this.textbookId = textbookId
    this.unitId = unitId
    this.lessonId = lessonId
    this.sectionId = sectionId
  },
  mounted() {
  },
  methods: {
    // 计算a-row的高度，视窗高度减88px
    calculateRowHeight() {
      return window.innerHeight - 120 + 'px';
    },
    // 计算a-textarea的高度，(视窗高度减144) × 80%
    calculateTextareaHeight() {
      return (window.innerHeight - 144) * 0.8 + 'px';
    },
    async importDrill() {
      if (!this.aiImportText.trim()) {
        this.$message.warning('请输入AI导题文本');
        return;
      }

      try {
        this.loading = true
        this.sourceDrillList = []
        this.drillList = []
        this.$message.loading('正在导入试题...', 0);
        let headers = {
          'User-Agent': 'Apifox/1.0.0 (https://apifox.com)',
          'Content-Type': 'application/json',
          'Accept': 'text/event-stream',
          'Host': 'fm-cloud-qa-fm-qa-lovlaauozw.cn-shenzhen.fcapp.run',
          'Connection': 'keep-alive',
          'Cache-Control': 'no-cache'
        }
        let token = localStorage.getItem('token')
        if(!token) {
          this.$message.error('请刷新页面重新登录');
          return;
        }
        headers.Authentication = token
        
        const response = await fetch('https://fm-cloud-qa-fm-qa-lovlaauozw.cn-shenzhen.fcapp.run/agent/chat/stream', {
          method: 'POST',
          headers: headers,
          body: JSON.stringify({
            message: this.aiImportText
          })
        });

        this.$message.destroy();

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        // 使用 ReadableStream 处理流式响应
        const reader = response.body.getReader();
        const decoder = new TextDecoder();
        while (true) {
          const { done, value } = await reader.read();
          
          if (done) {
            console.log('流式数据接收完成');
            this.$message.success('试题导入成功');
            break;
          }

          // 解码数据块
          const chunk = decoder.decode(value, { stream: true });
          console.log('接收到数据块:', chunk);
          const drillStr = chunk.replace('data:', '').trim()
          try{
            console.log('drillStr', drillStr)
            const drill = JSON.parse(drillStr)
            console.log(drill)
            drill.required = true
            drill.imageUri = undefined
            this.sourceDrillList.push(drill)
          } catch (error) {
            console.error('解析试题失败:', error);
          }
          // console.log(drill)
        }
      } catch (error) {
        this.$message.destroy();
        console.error('导入试题失败:', error);
        this.$message.error('导入试题失败: ' + error.message);
      }finally{
        this.loading = false
      }
    },
    updateDrill({index, drill}) {
      console.log('更新试题:', {index, drill})
      
      // 更新 sourceDrillList 中对应索引的试题
      if (index >= 0 && index < this.sourceDrillList.length) {
        // 使用 Vue.set 确保响应式更新
        this.$set(this.sourceDrillList, index, drill);
        console.log('试题更新成功，索引:', index);
      } else {
        console.error('无效的试题索引:', index);
      }
      // 同步更新 drillList（如果需要）
      this.drillList = [...this.sourceDrillList];
    }
  },
}
</script>

<style>

</style>